.container {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1, 8px);
  padding: var(--tuna-spacing-2, 16px) var(--tuna-spacing-2, 16px) var(--tuna-spacing-1, 8px);
  animation: fadeIn 100ms ease-out both;
}

@media (prefers-reduced-motion: reduce) {
  .container {
    animation: none;
  }
}

@keyframes fadeIn {
  from {
    opacity: 0;
  }
  to {
    opacity: 1;
  }
}

.prompts {
  display: flex;
  flex-direction: column;
  gap: var(--tuna-spacing-1, 8px);
  margin: 0;
  padding: 0;
  list-style: none;
}

/* Full-width rows: they fill the composer, they don't send (Joni) */
.prompt {
  appearance: none;
  width: 100%;
  background: transparent;
  border: 1px solid var(--tuna-palette-divider, rgba(0, 0, 0, 0.12));
  border-radius: var(--tuna-shape-borderRadius);
  padding: 8px 12px;
  font: inherit;
  font-size: var(--tuna-typography-fontSize-sm);
  color: var(--tuna-content-primary, var(--tuna-palette-text-primary));
  cursor: pointer;
  text-align: left;
  line-height: 1.4;
  transition:
    background-color 100ms ease-out,
    border-color 100ms ease-out;
}

.prompt:hover {
  background: var(--tuna-palette-action-hover, rgba(0, 0, 0, 0.04));
}

.prompt:focus-visible {
  outline: 2px solid var(--tuna-focus-ring, var(--tuna-palette-primary-main));
  outline-offset: 2px;
}

.hint {
  margin: 0;
  font-size: var(--tuna-typography-caption-fontSize);
  color: var(--tuna-palette-text-secondary);
}

@media (pointer: coarse) {
  .prompt {
    min-height: 44px;
  }
}

@media (prefers-reduced-motion: reduce) {
  .prompt {
    transition: none;
  }
}
